import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { ShoppingWithHeading } from './ShoppingWithHeading';
import { ShoppingWithTopModule } from './ShoppingWithTopModule';
import { ShoppingWithGrid } from './ShoppingWithGrid';
import { AllShoppersModal } from './AllShoppersModal';
import { getBuyerId } from 'dibs-cookie-jar';
import { addLoginHandlers } from 'dibs-buyer-layout/src/utils/loginHandlers';
import { ServerVarsContextConsumer } from '../sharedComponents/ServerVarsContext';

class ShoppingWithWrapperComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allShoppersOpen: false,
            isClient: false,
            userId: null,
        };
        this.handleOpenAllShoppers = this.handleOpenAllShoppers.bind(this);
        this.handleCloseAllShoppers = this.handleCloseAllShoppers.bind(this);
    }
    componentDidMount() {
        this.setState(
            {
                isClient: true,
                userId: getBuyerId(document.cookie),
            },
            () => {
                addLoginHandlers(() => {
                    const userId = getBuyerId(document.cookie) || null;
                    this.setState({ userId });
                });
            }
        );
    }
    handleOpenAllShoppers(e) {
        e.preventDefault();
        this.setState({ allShoppersOpen: true });
    }
    handleCloseAllShoppers() {
        this.setState({ allShoppersOpen: false });
    }
    render() {
        const { viewer, shoppingWith, relayEnvironment } = this.props;
        const { isClient, userId, allShoppersOpen } = this.state;
        return (
            <React.Fragment>
                <ShoppingWithHeading
                    shoppingWith={shoppingWith}
                    onOpenAllShoppers={this.handleOpenAllShoppers}
                />
                <ServerVarsContextConsumer>
                    {({ isMobile }) => (
                        <ShoppingWithTopModule
                            isMobile={isMobile}
                            shoppingWith={shoppingWith}
                            onOpenAllShoppers={this.handleOpenAllShoppers}
                        />
                    )}
                </ServerVarsContextConsumer>
                <ShoppingWithGrid
                    relayEnvironment={relayEnvironment}
                    viewer={viewer}
                    shoppingWith={shoppingWith}
                    isClient={isClient}
                    userId={userId}
                />
                <AllShoppersModal
                    viewer={viewer}
                    isOpen={allShoppersOpen}
                    onClose={this.handleCloseAllShoppers}
                />
            </React.Fragment>
        );
    }
}

ShoppingWithWrapperComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    shoppingWith: PropTypes.object.isRequired,
    relayEnvironment: PropTypes.object.isRequired,
};

export const ShoppingWithWrapper = createFragmentContainer(ShoppingWithWrapperComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithWrapper_shoppingWith on ShoppingWith {
            ...ShoppingWithHeading_shoppingWith
            ...ShoppingWithTopModule_shoppingWith
            ...ShoppingWithGrid_shoppingWith
        }
    `,
    viewer: graphql`
        fragment ShoppingWithWrapper_viewer on Viewer {
            ...AllShoppersModal_viewer
            ...ShoppingWithGrid_viewer
        }
    `,
});
